import { ETaskStatus } from '../conf/tasks';

export interface Task {
    Id: number;
    UserId: number;
    DeviceId: number;
    Status: number;
    Type: number;
    Progress: number;
    Result: any;
    CreatedAt: Date;
    UpdatedAt: Date;
    EndedAt: Date;
}

export const getTaskResult = (task: Task): string => {
    if (isTaskRunning(task)) {
        return 'RUNNING';
    }
    if (!task.Result) {
        return 'NO_TASK_INFO_AVAILABLE';
    }
    return JSON.stringify(task.Result);
};

export const getTaskProgress = (task: Task): number => {
    if ([ETaskStatus.ERROR, ETaskStatus.ABORTED].includes(task.Status)) {
        return 0;
    }
    return task.Result?.Ended ? 100 : task.Progress;
};

export const isTaskRunning = (task: Task): boolean => getTaskProgress(task) !== 100 && (task.Status === ETaskStatus.RUNNING || task.Status === ETaskStatus.PENDING);

export interface TaskState {
    Id: number;
    Name: string;
    Description: string;
}

export interface TaskType {
    Id: number;
    Name: string;
    Description: string;
}
